import { Box, IconButton, Typography } from '@mui/material';
import React from 'react';
import { BaseEdge, EdgeLabelRenderer, EdgeProps, getSmoothStepPath } from 'reactflow';
import DeleteIcon from '@mui/icons-material/Delete';
import { useFluxo } from "../../../../../../contexts/FlowContext";

export default function CustomEdge({
    id,
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
    style = {},
    markerEnd,
    selected,
    label
}: EdgeProps) {

    const {
        onRemoveEdge
    } = useFluxo();

    const [edgePath, labelX, labelY] = getSmoothStepPath({
        sourceX,
        sourceY,
        sourcePosition,
        targetX,
        targetY,
        targetPosition,
    });

    return (
        <>
            <BaseEdge
                path={edgePath}
                markerEnd={markerEnd}
                style={style}
            />
            <EdgeLabelRenderer>
                {
                    label &&
                    <Box
                        sx={{
                            bgcolor: "#ccc",
                            padding: 0.5,
                            borderRadius: 2,
                            position: 'absolute',
                            transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`
                        }}
                    >
                        <Typography variant='caption'> 
                            {label}
                        </Typography>
                    </Box>
                }

                {
                    selected &&
                    <IconButton
                        aria-label="delete"
                        onClick={() => onRemoveEdge(id)}
                        sx={{
                            position: 'absolute',
                            transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY - 40}px)`,
                            pointerEvents: 'all',
                        }}
                    >
                        <DeleteIcon color="error" />
                    </IconButton>
                }
            </EdgeLabelRenderer>
        </>
    )
}